module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Label.js"));
	}, "Label");
}